import * as React from "react";
import { forwardRef } from "react";
const SvgPodcastReplay = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 21, viewBox: "0 0 16 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8 4.00439V0.00439453L3 5.00439L8 10.0044V6.00439C11.31 6.00439 14 8.6944 14 12.0044C14 15.3144 11.31 18.0044 8 18.0044C4.69 18.0044 2 15.3144 2 12.0044H0C0 16.4244 3.58 20.0044 8 20.0044C12.42 20.0044 16 16.4244 16 12.0044C16 7.58439 12.42 4.00439 8 4.00439Z" }));
const ForwardRef = forwardRef(SvgPodcastReplay);
export { ForwardRef as ReactComponent };
